import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { Col, Row, Table } from 'reactstrap';
import EditButton from 'components/atoms/editButton';
import withLoader from 'components/organisms/withLoader';

const ClinicsThresholds = () => {
  const { clinicGuid } = useParams();
  const { getThreshold: thresholdLoading } = useSelector(
    (state) => state.loading.effects.adminPanelClinics,
  );

  const { threshold } = useSelector((state) => state.adminPanelClinics);
  return (
    <div className="admin-patient">
      <div>
        <div className="admin-patient-header">
          <span>Patient Thresholds</span>
          <div className="admin-patient-header-actions">
            <div className="admin-patient-header-actions-edit">
              <Link to={`/admin/clinic/${clinicGuid}/edit`}>
                <EditButton />
              </Link>
            </div>
          </div>
        </div>
      </div>
      {withLoader(
        thresholdLoading,
        <div className="admin-clinics-threshold-table__outer">
          <Table borderless border="0" cellSpacing="0" cellPadding="0">
            <thead>
              <tr>
                <th colSpan="2">
                  <div className="pagination-container">
                    <h5>Reading Type</h5>
                  </div>
                </th>
              </tr>
            </thead>
            {threshold && (
              <tbody>
                <tr>
                  <Row style={{ padding: '15px' }}>
                    <Col>
                      <h5>Systolic</h5>
                    </Col>
                    <Col>
                      <span>Max Critical: {threshold.maxCriticalSystolic}</span>
                      <span className="subheader">
                        Max At Risk: {threshold.maxRiskSystolic}
                      </span>
                    </Col>
                    <Col>
                      <span>Min Critical: {threshold.minCriticalSystolic}</span>
                      <span className="subheader">
                        Min At Risk: {threshold.minRiskSystolic}
                      </span>
                    </Col>
                  </Row>

                  <Row style={{ padding: '15px' }}>
                    <Col>
                      <h5>Sp02</h5>
                    </Col>
                    <Col>
                      <span>Max Critical: {threshold.criticalBloodoxygen}</span>
                    </Col>
                    <Col>
                      <span className="subheader">
                        Min At Risk: {threshold.riskBloodoxygen}
                      </span>
                    </Col>
                  </Row>

                  <Row style={{ padding: '15px' }}>
                    <Col>
                      <h5>Diastolic</h5>
                    </Col>
                    <Col>
                      <span>
                        Max Critical: {threshold.maxCriticalDiastolic}
                      </span>
                      <span className="subheader">
                        Max At Risk: {threshold.maxRiskDiastolic}
                      </span>
                    </Col>
                    <Col>
                      <span>
                        Min Critical: {threshold.minCriticalDiastolic}
                      </span>
                      <span className="subheader">
                        Min At Risk: {threshold.minRiskDiastolic}
                      </span>
                    </Col>
                  </Row>

                  <Row style={{ padding: '15px' }}>
                    <Col>
                      <h5>Glucose</h5>
                    </Col>
                    <Col>
                      <span>Max Critical: {threshold.maxCriticalGlucose}</span>
                      <span className="subheader">
                        Max At Risk: {threshold.maxRiskGlucose}
                      </span>
                    </Col>
                    <Col>
                      <span>Min Critical: {threshold.minCriticalGlucose}</span>
                      <span className="subheader">
                        Min At Risk: {threshold.minRiskGlucose}
                      </span>
                    </Col>
                  </Row>

                  <Row style={{ padding: '15px' }}>
                    <Col>
                      <h5>Pulse</h5>
                    </Col>
                    <Col>
                      <span>Max Critical: {threshold.maxCriticalPulse}</span>
                      <span className="subheader">
                        Max At Risk: {threshold.maxRiskPulse}
                      </span>
                    </Col>
                    <Col>
                      <span>Min Critical: {threshold.minCriticalPulse}</span>
                      <span className="subheader">
                        Min At Risk: {threshold.minRiskPulse}
                      </span>
                    </Col>
                  </Row>
                  <Row style={{ padding: '15px' }}>
                    <Col>
                      <h5>Weight</h5>
                    </Col>
                    <Col>
                      <span>Max Critical: {threshold.maxCriticalWeight}</span>
                      <span className="subheader">
                        Max At Risk: {threshold.maxRiskWeight}
                      </span>
                    </Col>
                    <Col>
                      <span>Min Critical: {threshold.minCriticalWeight}</span>
                      <span className="subheader">
                        Min At Risk: {threshold.minRiskWeight}
                      </span>
                    </Col>
                  </Row>
                  <Row style={{ padding: '15px' }}>
                    <Col>
                      <h5>Resting Pulse</h5>
                    </Col>
                    <Col>
                      <span>
                        Max Critical: {threshold.maxCriticalSleepPulse}
                      </span>
                      <span className="subheader">
                        Max At Risk: {threshold.maxRiskSleepPulse}
                      </span>
                    </Col>
                    <Col>
                      <span>
                        Min Critical: {threshold.minCriticalSleepPulse}
                      </span>
                      <span className="subheader">
                        Min At Risk: {threshold.minRiskSleepPulse}
                      </span>
                    </Col>
                  </Row>
                  <Row style={{ padding: '15px' }}>
                    <Col>
                      <h5>Pef</h5>
                    </Col>
                    <Col />
                    <Col>
                      <span>Min Critical: {threshold.minCriticalPef}</span>
                      <span className="subheader">
                        Min At Risk: {threshold.minRiskPef}
                      </span>
                    </Col>
                  </Row>
                  <Row style={{ padding: '15px' }}>
                    <Col>
                      <h5>FEV1</h5>
                    </Col>
                    <Col />
                    <Col>
                      <span>Min Critical: {threshold.minCriticalFev1}</span>
                    </Col>
                  </Row>
                </tr>
              </tbody>
            )}
          </Table>
        </div>,
      )}
    </div>
  );
};

export default ClinicsThresholds;
